/**
 * Dev-only logger. In production builds we silence non-critical warnings to
 * avoid leaking internal state / hurting perf. Errors still bubble.
 */
const isDev =
  typeof process !== "undefined" &&
  process.env &&
  process.env.NODE_ENV !== "production";

export const devWarn = isDev ? console.warn.bind(console) : () => {};
export const devInfo = isDev ? console.info.bind(console) : () => {};
